import React from "react";
import { PartyPopper, ArrowUpRight } from "lucide-react";
import { Button } from "./ui/button";
import { SPECIALS } from "../mock";

// Shows the Halloween Party banner until the end of event day (Oct 30, 2026, Pacific). Hidden automatically afterwards.
const EVENT_END = new Date("2026-10-31T06:59:59Z");

export const HalloweenBanner = () => {
  const event = SPECIALS.find((s) => s.id === "halloween");
  if (!event || !event.url || Date.now() > EVENT_END.getTime()) return null;
  return (
    <section className="bg-[#1A1A1A] text-white" data-testid="halloween-banner">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-4 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
        <div className="flex items-start gap-3 flex-1">
          <div className="h-10 w-10 rounded-full bg-[#ff7a00]/20 flex items-center justify-center shrink-0">
            <PartyPopper className="text-[#ff9d3c]" size={20} />
          </div>
          <div>
            <p className="font-display font-extrabold text-base sm:text-lg leading-tight">
              {event.name} — Friday, October 30 · 5–8 PM <span className="text-br-yellow">· {event.price} {event.unit}</span>
            </p>
            <p className="text-sm text-neutral-300 mt-0.5">Pizza party! Every kid can bring a buddy free of charge.</p>
          </div>
        </div>
        <a href={event.url} target="_blank" rel="noreferrer" data-testid="halloween-register-btn" className="shrink-0">
          <Button className="h-11 px-6 bg-br-yellow hover:bg-[#e6c900] text-[#1A1A1A] rounded-full font-extrabold w-full sm:w-auto">
            Register Now <ArrowUpRight size={16} className="ml-1" />
          </Button>
        </a>
      </div>
    </section>
  );
};

export default HalloweenBanner;
